import React from 'react'
import '../../App.css'

export const GameOver = ({isGameOver, value,replay, counter, enemy}) => {
  return (
    <div className={isGameOver | counter===0? ' gameOver-wrapper active':"gameOver-wrapper"}>

    <div className={'gameover'}><span className='winner'>{isGameOver? value ==='x'? 'Winner is '+'o':'Winner is '+'x':'DRAW'}</span></div>
    <input value={'Replay'} type={'button'} className ='replay' onClick={()=>replay()}/>

    </div>
  )
}
